import React from 'react';
import { Link } from 'react-router-dom';
import { Gem, Leaf, Users, Shield } from 'lucide-react';
import './AboutPage.css';

const AboutPage = () => {
  return (
    <div className="about-page">
      <section className="about-hero">
        <div className="container">
          <h1 className="page-title font-heading">About Lava Co</h1>
          <p className="page-subtitle">Cleaning Los Angeles, One Home at a Time</p>
        </div>
      </section>

      <section className="about-content">
        <div className="container">
          <div className="about-story">
            <h2 className="section-heading font-heading">Our Story</h2>
            <p>Lava Co was born from a simple frustration: finding a cleaning service you can actually trust. We saw too many homeowners and property managers dealing with flaky cleaners, hidden fees, and inconsistent results.</p>
            <p>So we built something different. A cleaning company that treats your home like it's our own. Where transparency isn't a buzzword — it's how we operate. Where "professional" means showing up on time, every time, and leaving your space spotless.</p>
            <p>Today, we serve hundreds of satisfied clients across Los Angeles and surrounding areas. From busy professionals who need weekly maid service, to Airbnb hosts who depend on us for same-day turnovers, to homeowners preparing for that big move.</p>
          </div>

          <div className="about-values">
            <h2 className="section-heading font-heading">What We Stand For</h2>
            <div className="values-grid">
              <div className="value-card">
                <h3><Gem size={18} strokeWidth={1.5} className="inline-block mr-2 align-text-bottom" />Quality First</h3>
                <p>We don't cut corners. Every clean gets the same attention to detail, whether it's a quick touch-up or a full deep clean.</p>
              </div>
              <div className="value-card">
                <h3><Users size={18} strokeWidth={1.5} className="inline-block mr-2 align-text-bottom" />Transparency</h3>
                <p>Know exactly what you're paying for. No hidden fees. No surprise charges. Just honest, upfront pricing.</p>
              </div>
              <div className="value-card">
                <h3><Shield size={18} strokeWidth={1.5} className="inline-block mr-2 align-text-bottom" />Reliability</h3>
                <p>Your time matters. We show up when we say we will, and we finish the job right. Every single time.</p>
              </div>
              <div className="value-card">
                <h3><Leaf size={18} strokeWidth={1.5} className="inline-block mr-2 align-text-bottom" />Accountability</h3>
                <p>Something not right? We make it right. 100% satisfaction guaranteed, no questions asked.</p>
              </div>
            </div>
          </div>

          <div className="about-team">
            <h2 className="section-heading font-heading">Our Team</h2>
            <p className="team-intro">Every Lava Co cleaner is background-checked, insured, and trained in our proven cleaning methods. We're not just employees — we're professionals who take pride in our work.</p>
            <p className="team-intro">When you book with Lava Co, you're getting experienced cleaners who know what they're doing. People you can trust in your home.</p>
          </div>

          <div className="about-cta">
            <h2 className="cta-heading font-heading">Experience the Lava Co Difference</h2>
            <p>Join hundreds of satisfied Los Angeles clients</p>
            <Link to="/book" className="btn btn-primary btn-large">
              Book Your First Cleaning
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
